import {mixpanel} from "../util/mixpanel";
import {renderCalendar} from "../calendar/calendar.js";
import {getDefaultCalendarDirection, getDefaultWeekStartDay, isRtlLanguage} from "../util/localization.js";
import {currentTime} from "../datetime/time";



export function getCalDirection() {
    return localStorage.getItem("cal-direction") || getDefaultCalendarDirection();
}

function saveCalDirection(unit) {
    localStorage.setItem("cal-direction", unit);
}


export function getWeekStartDay() {
    return localStorage.getItem("week-start-day") || getDefaultWeekStartDay();
}

export function getClockType() {
    return localStorage.getItem("clock-type") || "locale";
}

function saveWeekStartDay(unit) {
    localStorage.setItem("week-start-day", unit);
}

function saveClockType(unit) {
    localStorage.setItem("clock-type", unit);
}


export function changeCalDirection(event) {
    let inactiveUnit = event.target;
    let value = inactiveUnit.getAttribute("data-value");
    let name = inactiveUnit.getAttribute("name");

    mixpanel.track('Settings', {"value": value, "name": name});
    document.documentElement.setAttribute('dir', value);
    document.documentElement.style.direction = value;
    saveCalDirection(value);
}


export function changeWeekStartDay(event) {
    let inactiveUnit = event.target;
    let value = inactiveUnit.getAttribute("data-value");
    let name = inactiveUnit.getAttribute("name");

    mixpanel.track('Settings', {"value": value, "name": name});
    saveWeekStartDay(value);
    renderCalendar();
}

export function changeClockType(event) {
    let inactiveUnit = event.target;
    let value = inactiveUnit.getAttribute("data-value");
    let name = inactiveUnit.getAttribute("name");

    mixpanel.track('Settings', {"value": value, "name": name});
    saveClockType(value);
    currentTime();
}

export function initCalDirection() {
    let direction = document.querySelector('.settings input[name="calendar_direction"]:checked').getAttribute("data-value");
    document.documentElement.setAttribute('dir', direction);
    document.documentElement.style.direction = direction;
    // show direction setting for rtl languages
    if (isRtlLanguage()) {
        document.getElementById("calendar_direction_name").parentElement.classList.remove("hidden");
    }
}